<template>
    <div>

   
    <div  class="weui-cell" style="border-bottom: 1px solid rgba(0,0,0,0.1);"> 
        <div class="cell-hd" style="width:120px;padding-bottom: 5px;">           
            <font style="color: red;"  v-if="tb.ismust">*</font>
            <font>{{tb.name}} </font>        

        </div>       
        <div @click="picker" :style="{color:val1?'black':'rgb(161, 157, 157)'}" style="color:rgb(161, 157, 157);padding-bottom: 5px;" class="cell-bd" >
            {{val1?val1:'请选择'+tb.name}}   
        </div>
        <a v-if="val1" @click="val1=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a> 
    </div>
   


    <template v-if="tb.detailadd">
    <div style="height: 10px;"></div>
	<div >	
		<div   class="weui-cell" style="border-bottom: 1px solid rgba(0,0,0,0.1);">        
			<div class="weui-cell__hd"  style="width:120px;padding-bottom: 5px;">
				
				<font>详细地址</font>      
			</div>			           
			<label  style="flex:1;padding-bottom: 5px;">
			  <input 			  
			  :style="{color:val2?'black':'rgb(161, 157, 157)'}"                 
			  style="width:80%;background-color:transparent;color:rgb(161, 157, 157);"
				   v-model="val2"
                   placeholder="请填写详细地址"						
			  />
			</label> 
			<a v-if="val2" @click="val2=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a>             
		</div>		
	</div>
</template>


    <br>
</div>
</template>


<script>
import {picker4ji} from '@/js/picker4ji.js'
import {Howl, Howler} from 'howler';
var sound = new Howl({
  src: ['./static/light.mp3'],
  volume: 0.1
});


export default{
    props:['tb'],
    data(){
        return{
            val1:"",
            val2:"",    
        }
    },
    created(){
        if(this.tb.val){
          let va =  this.tb.val.split(',');
          this.val1 = va[0];
          if(va[1]){
              this.val2= va[1];
          }
        }
    },
    watch:{
        val1(){

            this.tb.val = this.val1+(this.val2?",":"")+this.val2;
   
        },
        val2(){
           
            this.tb.val = this.val1+(this.val2?",":"")+this.val2;
           
        }
    },
    methods:{

        picker(){
            weui.picker(picker4ji, {
        depth: this.tb.depth,
        defaultValue: [0, 1, 1],
        onChange:(result)=> {
          
            

          
        },
        onConfirm: (result)=> {
            
            if(this.tb.depth==4){
                this.val1 = result[0].label+' '+result[1].label+' '+result[2].label+' '+result[3].label;
            }
            if(this.tb.depth==3){
                this.val1 = result[0].label+' '+result[1].label+' '+result[2].label;
            }
            if(this.tb.depth==2){
                this.val1 = result[0].label+' '+result[1].label;
            }
            if(this.tb.depth==1){
                this.val1 = result[0].label;
            }
            
        },
        id: 'cascadePicker',
        title: '省市区县选择'
    });
        }
    }
}
</script>


<style>
    .cell-hd{
 padding-top: 16px;
  display: flex;
  align-items: center;
 width:100px; 
    }
    .cell-bd{
  padding-top: 16px;
  display: flex;
  align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
    }



</style>


// WEBPACK FOOTER //
// src/fields/AddPicker.vue